$('.abz_img_block .text_slider_block .text_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: false,
  arrows:true,
  infinite: true,
  centerMode: true,
  prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="15" cy="15" r="15" fill="#138046"/><path d="M8 15L15.5 10V13.75H23V16.25H15.5V20L8 15Z" fill="white"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="15.001" cy="15" r="15" transform="rotate(-180 15.001 15)" fill="#138046"/><path d="M23.001 15L15.501 20V16.25L8.00098 16.25L8.00098 13.75L15.501 13.75L15.501 10L23.001 15Z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 1290,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});



// match height;
// var x = window.matchMedia("(max-width: 768px)")
// (function matchHeight(){
//   var getDivs = document.getElementsByClassName('article-card__title');  
//   var arrayLength = getDivs.length;
//   var heights = [];

//   for (var i = 0; i < arrayLength; i++) {
//       heights.push(getDivs[i].offsetHeight);
//   }

//   function getHighest() {
//     return Math.max(...heights);
//   }

//   var tallest = getHighest();

//   for (var i = 0; i < getDivs.length; i++) {
//       getDivs[i].style.height = tallest + "px";
//   }
// })();

// (function matchHeight(){
//   var getDivs = document.getElementsByClassName(' article-card__summary ');  
//   var arrayLength = getDivs.length;
//   var heights = [];

//   for (var i = 0; i < arrayLength; i++) {
//       heights.push(getDivs[i].offsetHeight);
//   }

//   function getHighest() {
//     return Math.max(...heights);
//   }

//   var tallest = getHighest();

//   for (var i = 0; i < getDivs.length; i++) {
//       getDivs[i].style.height = tallest + "px";
//   }
// })();

// same hieght js
// $(document).ready(function(){
  
//   // Card height function
//   function refreshCardHeight(){
//     // Reset height to 0
//     var maxHeight = 0;
//     $(".abz_vertical_line .text-columns-contents .text , .abz_vendor_list .text").css('height', '');
    
//     // Get the highest card height
//     $(".abz_vertical_line .text-columns-contents .text , .abz_vendor_list .text").each(function(){
//       if ($(this).height() > maxHeight) { 
//         maxHeight = $(this).height(); 
//       }
//     });
    
//     // Set new highest height
//      $(".abz_vertical_line .text-columns-contents .text , .abz_vendor_list .text").height(maxHeight);
//   }

//   //run on page ready
//   refreshCardHeight();

//   // Trigger when window is resized
//   $( window ).resize(function() {
//     refreshCardHeight();
//   });

// }); 

/ End /


// Height js

// function init() {
  
//   var i = 0;
//   var items = document.querySelectorAll(" .abz_vendor_list .text"); 
//   var itemsHeight = [];
  
//   console.log(items);
//   console.log(itemsHeight);
  
//   for (i = 0; i < items.length; i++) {
    
//     itemsHeight.push(items[i].offsetHeight);
//   }
  
//   var maxHeight = Math.max(...itemsHeight);
  
//   for (i = 0; i < items.length; i++) {
  
//     items[i].style.height = maxHeight + "px";
//   }
// }

// init();

